function getPaths() {
  return (
    window
    .location
    .pathname
    .split("/")
    .filter(p => p.length > 0)
  );
}

function getLanguageCode() {
  return getPaths()[0];
}

function getCampaignName() {
  return getPaths()[1];
}

export default {
  getLanguageCode,
  getCampaignName
}